<template>
  <section :class="$style['unbounce-rewards-rows']">
    <home-info-row
      src="/img/unbounce/unbounceRewardsRow1.jpeg"
      :alt="$t('money.from.laptop')"
      :imgClass="$style['row-1-img']"
      :headline="$t('unbounce.rewards.row-1.headline')"
      :firstCategoryParagraphs="row1.firstCategoryParagraphs"
      :containerClass="$style['unbounce-rewards-rows']"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row1.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :src="src"
        :class="$style['rewards-container']"
        :alt="alt"
      />
    </home-info-row>
    <home-info-row
      videoSrc="https://www.youtube.com/embed/pB_E39Z1hsc"
      :alt="$t('home.img.alt.girl')"
      :headline="$t('home.row-info-1.headline')"
      :firstCategoryParagraphs="row2.firstCategoryParagraphs"
      :containerClass="$style['row-2-container']"
      class="row-reverse"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row2.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :class="$style['rewards-container']"
        :src="src"
        :alt="alt"
      />
    </home-info-row>
    <home-info-row
      videoSrc="https://www.youtube.com/embed/mMTkVsXM1_Q"
      :alt="$t('home.img.alt.girl')"
      :headline="$t('home.row-info-1.headline')"
      :firstCategoryParagraphs="row3.firstCategoryParagraphs"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row3.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :class="$style['rewards-container']"
        :src="src"
        :alt="alt"
      />
    </home-info-row>
  </section>
</template>

<script>
import HomeInfoRow from '@/components/home/HomeInfoRow.vue';
import RewardsItem from '@/components/rewards/RewardsItem.vue';

export default {
  components: {
    HomeInfoRow,
    RewardsItem,
  },
  data() {
    return {
      row1: {
        firstCategoryParagraphs: [
          this.$t('unbounce.rewards.row-1.p1'),
          this.$t('unbounce.rewards.row-1.p2'),
        ],
        secondCategoryParagraphs: [
          [this.$t('unbounce.rewards.row-1.p3')],
          [this.$t('unbounce.rewards.row-1.p4')],
        ],
      },
      row2: {
        firstCategoryParagraphs: [
          this.$t('unbounce.rewards.row-2.p1'),
          this.$t('unbounce.rewards.row-2.p2'),
        ],
        secondCategoryParagraphs: [
          [this.$t('unbounce.rewards.row-2.p3')],
          [this.$t('unbounce.rewards.row-2.p4')],
          [this.$t('unbounce.rewards.row-2.p5')],
          [this.$t('unbounce.rewards.row-2.p6')],
        ],
      },
      row3: {
        firstCategoryParagraphs: [
          this.$t('unbounce.rewards.row-3.p1'),
          this.$t('unbounce.rewards.row-3.p2'),
        ],
        secondCategoryParagraphs: [
          [this.$t('unbounce.rewards.row-3.p3')],
          [this.$t('unbounce.rewards.row-3.p4')],
          [this.$t('unbounce.rewards.row-3.p5')],
        ],
      },
      src: '/img/icons/check.svg',
      alt: this.$t('rewards.group-1.iconAlt'),
    };
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/styles/colors.scss';

.unbounce-rewards-rows {
  section,
  p {
    margin-bottom: 0 !important;
  }
  iframe {
    width: 470px;
    height: 264px;
  }
  p {
    padding-bottom: 15px;
    color: $dark-grey !important;
    font-size: 14px;
  }
}

.rewards-container {
  font-weight: bold;
}

.row-container {
  margin: 50px;
  width: 1000px !important;
}

.row-container.row-reverse {
  flex-direction: flex-end;
}

.row-2-container {
  max-width: 450px;
}

.row-1-img {
  width: 471px !important;
  height: 313px !important;
}
</style>
